function initTabSwitcher(tabSelector, panelSelector, dataAttr) {
  var tabs = document.querySelectorAll(tabSelector);
  var panels = document.querySelectorAll(panelSelector);

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');

      var target = tab.dataset[dataAttr];
      panels.forEach(function (panel) {
        panel.classList.remove('active');
        if (panel.id === target) {
          panel.classList.add('active');
        }
      });
    });
  });
}

function initDragScroll(elementId) {
  var slider = document.getElementById(elementId);
  if (!slider) return;

  var isDown = false;
  var startX;
  var scrollLeft;

  slider.addEventListener('mousedown', function (e) {
    isDown = true;
    slider.classList.add('grabbing');
    startX = e.pageX - slider.getBoundingClientRect().left;
    scrollLeft = slider.scrollLeft;
  });

  ['mouseleave', 'mouseup'].forEach(function (evt) {
    slider.addEventListener(evt, function () {
      isDown = false;
      slider.classList.remove('grabbing');
    });
  });

  slider.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    var x = e.pageX - slider.getBoundingClientRect().left;
    slider.scrollLeft = scrollLeft - (x - startX);
  });

  slider.addEventListener('touchstart', function (e) {
    isDown = true;
    startX = e.touches[0].pageX - slider.getBoundingClientRect().left;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('touchend', function () {
    isDown = false;
  });

  slider.addEventListener('touchmove', function (e) {
    if (!isDown) return;
    var x = e.touches[0].pageX - slider.getBoundingClientRect().left;
    slider.scrollLeft = scrollLeft - (x - startX);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initTabSwitcher('.notes-tab', '.tab-panel', 'tab');
  initDragScroll('notesTabs');

  initTabSwitcher('.feel-tab', '.feel-panel', 'feel');
  initDragScroll('feelTabs');

  initTabSwitcher('.behind-tab', '.behind-panel', 'behind');
  initDragScroll('behindTabs');
});
